var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocLibrary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "capture_tool",
    "data-name": "capture tool",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    className: "themeSVGStroke themeSVGStrokeHover",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "art"
  }, /*#__PURE__*/React.createElement("path", {
    className: "themeable",
    id: "Path_10728",
    "data-name": "Path 10728",
    d: "M16.45,10.35C16.8,8,16.17,6.88,14.85,7c-1.08.1-1.2,1.57-1,3.2a11.61,11.61,0,0,0,3.46,6.6c4.94,5.21,8,4.09,8.25,3.17.31-1.12-.89-2.32-3.18-2.31a35.89,35.89,0,0,0-7,1.28A19.14,19.14,0,0,0,8.8,21.18c-1.28.91-2.2,2.53-1.47,3.31s2.38.2,3.4-1.33A37.34,37.34,0,0,0,16.45,10.35Z",
    fill: "none",
    stroke: "#3c4347",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "themeable",
    id: "Rectangle_1983",
    "data-name": "Rectangle 1983",
    x: 3,
    y: 3,
    width: 26,
    height: 26,
    fill: "none",
    stroke: "#3c4347",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    vectorEffect: "non-scaling-stroke"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "square"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1984",
    "data-name": "Rectangle 1984",
    width: 32,
    height: 32,
    style: {
      fill: "none"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocLibrary);
export default __webpack_public_path__ + "static/media/doc_library.f2fd77d92f332c339518547bbecc0ef7.svg";
export { ForwardRef as ReactComponent };